import type { ReactNode } from 'react';

/**
 * Shell for public (unauthenticated) routes. No extra providers; just renders children.
 * Used for landing, login, forms, etc.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
